<template>
  <div class="home">
    <div class="pic-info-box">
      <div class="pic-box">
        <pic-roll></pic-roll>
      </div>
      <div class="info-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="新闻公告" name="news">
            <NewsList :show-title="false" :show-page="false" :page-size="8"></NewsList>
          </el-tab-pane>
          <el-tab-pane label="历史项目" name="project">
            <ProjectList :col="5" :showTitle="false" :show-page="false" :page-size="8"></ProjectList>
          </el-tab-pane>
        </el-tabs>
        <div class="show-more" @click="goList">[ 更多 ]</div>
      </div>
    </div>
    <CompanyInfo :showTitle="true" :showRight="false"></CompanyInfo>
  </div>
</template>

<script>
import CompanyInfo from "@/components/style2/CompanyInfo.vue";
import HomePic from "@/components/style2/HomePic.vue";
import ProjectList from "@/components/style2/ProjectList.vue";
import NewsList from "@/components/style2/NewsList.vue";
import PicRoll from "@/components/style2/PicRoll.vue";

export default {
  name: 'Home',
  components: {
    HomePic, CompanyInfo, ProjectList, NewsList, PicRoll
  },
  data() {
    return {
      activeName: 'news'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    goList() {
      let index = this.activeName === 'news' ? 4 : 3
      this.jump('/style2/' + this.activeName, {navIndex: index})
    }
  }
};
</script>

<style lang="less">

.el-tabs__active-bar {
  background-color: #7f8f9e;
}

.el-tabs__item {
  font-size: 20px;
  font-weight: 700;
  color: #7d7d7d;
}

.el-tabs__item.is-active {
  color: #153161;
}
</style>
